<template>
    <StudyPlanComponent />
</template>


<script>
import StudyPlanComponent from '../../components/study_plan/study_plan_component.vue'

export default {
    data() {
        return {

        }
    },
    methods : {
    },
    components: {
        StudyPlanComponent
    }
}
</script>